// extracted by mini-css-extract-plugin
module.exports = {"btn":"WalletButton_btn__3OSqI","btn_connected":"WalletButton_btn_connected__253m3","profile":"WalletButton_profile___j63E","btn_disconnect":"WalletButton_btn_disconnect__tjedN"};